import styled from 'styled-components'
import {airBlue, white} from '@modifi/colors'

export const BadgeIcon = styled.i`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  height: 18px;
  width: 18px;
  line-height: 18px;
  border-radius: 10px;
  background: ${airBlue};
  color: ${white};
  text-align: center;
  margin-right: 8px;
`
